/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirstClip,
    FirstClipFromJSON,
    FirstClipFromJSONTyped,
    FirstClipToJSON,
} from './FirstClip';

/**
 * 
 * @export
 * @interface GetFirstClipResponse
 */
export interface GetFirstClipResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetFirstClipResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetFirstClipResponse
     */
    message: string;
    /**
     * 
     * @type {FirstClip}
     * @memberof GetFirstClipResponse
     */
    data: FirstClip;
}

export function GetFirstClipResponseFromJSON(json: any): GetFirstClipResponse {
    return GetFirstClipResponseFromJSONTyped(json, false);
}

export function GetFirstClipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFirstClipResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': FirstClipFromJSON(json['data']),
    };
}

export function GetFirstClipResponseToJSON(value?: GetFirstClipResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': FirstClipToJSON(value.data),
    };
}

